// src/pages/NewJobForm.js
import  { useState } from "react";
import { useDispatch } from "react-redux";
import { addJob } from "./../redux/jobActions"; // Adjust path as needed

const NewJobForm = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    jobCategory: "",
    jobType: "",
    position: "",
    numberOfVacancies: "",
    experience: "",
    gender: "",
    salaryFrom: "",
    salaryTo: "",
    city: "",
    state: "",
    educationLevel: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Optional: Validation
    dispatch(addJob(formData));
  };

  const styles = {
    container: {
      background: "#fff",
      padding: "30px",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      maxWidth: "1200px",
      margin: "0 auto",
      fontFamily: "Arial, sans-serif",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
    },
    formGrid: {
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
    },
    inputBox: {
      flex: "1 1 calc(33.333% - 20px)",
      minWidth: "250px",
      display: "flex",
      flexDirection: "column",
    },
    label: {
      marginBottom: "5px",
      fontSize: "14px",
      fontWeight: "500",
    },
    input: {
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      fontSize: "14px",
    },
    textarea: {
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      fontSize: "14px",
      minHeight: "80px",
    },
    radioGroup: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      marginTop: "10px",
    },
    buttonGroup: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "15px",
      marginTop: "30px",
    },
    button: {
      padding: "10px 20px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "14px",
    },
    closeButton: {
      backgroundColor: "#fff",
      border: "1px solid #1976d2",
      color: "#1976d2",
    },
    submitButton: {
      backgroundColor: "#1976d2",
      color: "#fff",
    },
  };

  return (
    <form style={styles.container} onSubmit={handleSubmit}>
      <div style={styles.heading}>New Job</div>
      <div style={styles.formGrid}>
        {/* Row 1 */}
        <div style={styles.inputBox}>
          <label style={styles.label}>Job Category *</label>
          <input
            type="text"
            name="jobCategory"
            value={formData.jobCategory}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        <div style={styles.inputBox}>
          <label style={styles.label}>Job Type *</label>
          <input
            type="text"
            name="jobType"
            value={formData.jobType}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        <div style={styles.inputBox}>
          <label style={styles.label}>Position *</label>
          <input
            type="text"
            name="position"
            value={formData.position}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        {/* Row 2 */}
        <div style={styles.inputBox}>
          <label style={styles.label}>Experience *</label>
          <input
            type="text"
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        {/* <div style={styles.inputBox}>
          <label style={styles.label}>Gender *</label>
          <input
            type="text"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            style={styles.input}
          />
        </div> */}
        <div style={styles.inputBox}>
          <label style={styles.label}>Number of Vacancies *</label>
          <input
            type="number"
            name="numberOfVacancies"
            value={formData.numberOfVacancies}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        {/* Row 3 */}
        <div style={styles.inputBox}>
          <label style={styles.label}>Salary From *</label>
          <input
            type="number"
            name="salaryFrom"
            value={formData.salaryFrom}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        <div style={styles.inputBox}>
          <label style={styles.label}>Salary To *</label>
          <input
            type="number"
            name="salaryTo"
            value={formData.salaryTo}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        {/* <div style={styles.inputBox}>
          <label style={styles.label}>City *</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            style={styles.input}
          />
        </div> */}

        {/* Row 4 */}
        <div style={styles.inputBox}>
          <label style={styles.label}>State *</label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        <div style={styles.inputBox}>
          <label style={styles.label}>Education Level *</label>
          <input
            type="text"
            name="educationLevel"
            value={formData.educationLevel}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        <div style={{ ...styles.inputBox, flex: "1 1 100%" }}>
          <label style={styles.label}>Description *</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            style={styles.textarea}
          />
        </div>
      </div>

      {/* Buttons */}
      <div style={styles.buttonGroup}>
        <button
          type="button"
          style={{ ...styles.button, ...styles.closeButton }}
          onClick={() => setFormData({})}
        >
          Close
        </button>
        <button type="submit" style={{ ...styles.button, ...styles.submitButton }}>
          Submit
        </button>
      </div>
    </form>
  );
};

export default NewJobForm;
